
// Import module styles.
import "./selectRecentExercise.view.less";
